import { ButtonAddHLPure, GridPure, ModalUtil, SearchBarHLPure } from '../../pures'
import { Grid, useMediaQuery } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useMemo, useState } from 'react'

const UserAdministrationList = (props) => {
    // #region variables
    const {
        t,
        users,
        createNewUser,
        updateUserStatus,
        setSelectedUser
    } = props

    const { t: tCommon } = useTranslation('common')
    const modalUtil = new ModalUtil()
    const hideActions = useMediaQuery('(max-width: 820px)')

    const [searchUser, setSearchUser] = useState('')
    // #endregion variables

    // #region effects
    const usersTransformed = useMemo(() => {
        return users.map(v => ({
            ...v,
            status: v.status === 'active' ? t('statusEnabled') : t('statusDisabled')
        }))
    }, [users, t])

    const userGrid = useMemo(() => {
        if (!searchUser) return usersTransformed;

        const lowercasedSearchUser = searchUser.toLowerCase()
        const filteredUsers = usersTransformed.filter(el => el.name.toLowerCase().includes(lowercasedSearchUser) ||
            el.email.includes(lowercasedSearchUser))
        return filteredUsers
    }, [usersTransformed, searchUser])
    // #endregion effects

    // #region methods
    const handleChangeSearch = (e) => setSearchUser(e.target.value);
    // #endregion methods

    // #region jsx-elements
    const selectOption = () => {
        modalUtil.mainModal(t("addUser"), () => {
            document.getElementById('buttonclick').addEventListener('click', async () => {
                await createNewUser(document.getElementById('emailUser').value)
            })

        }, `<label class="eticket-form-label">${tCommon("mail")}</label>
        <div style="margin-bottom: 15px;"><input type="text" id="emailUser" class="eticket-input-field"/></div>
    <div style="display: flex; justify-content: flex-end;"><button style="margin-top: 24px; display: inline-block;" id="buttonclick" class="buttonHLPure buttonHLPure-primary">${tCommon("save")}</button></div>`)
    }
    // #endregion jsx-elements

    return (
        <>
            <Grid item xs={12} className="add-and-search-container">
                <ButtonAddHLPure
                    iconAdd={true}
                    nameBtn={t("addUser")}
                    onClickBtn={selectOption}
                />
                <SearchBarHLPure
                    placeholder={tCommon("search")}
                    onSearchChange={((e) => handleChangeSearch(e))}
                />
            </Grid>
            <Grid item xs={12}>
                <GridPure
                    {...props}
                    dataGrid={userGrid}
                    skip={0}
                    take={11}
                    rowsItems={[
                        {
                            field: 'name',
                            title: t('users'),
                            width: 200,
                            sorteable: true
                        },
                        {
                            field: 'email',
                            title: tCommon("mail"),
                            width: 200,
                            sorteable: true
                        },
                        {
                            field: 'status',
                            title: t('status'),
                            width: 100,
                            sorteable: true
                        },
                        {
                            field: 'Acciones',
                            title: tCommon('actions'),
                            width: hideActions ? 80 : 200,
                            actions: true,
                            headerClassName: 'actionHeader'
                        }]}
                    actions={[
                        {
                            type: 'view-details',
                            value: tCommon('details'),
                            onClick: (dataItem) => {
                                setSelectedUser(dataItem)
                            }
                        },
                        {
                            type: 'label',
                            value: (dataItem) => dataItem.active ? t('disable') : t('enable'),
                            onClick: (dataItem) => {
                                updateUserStatus(!dataItem.active, dataItem.email)
                            }
                        },
                    ]}
                />
            </Grid>
        </>
    )
}

export default UserAdministrationList